// Existing testimonial imports
import maoli from '@/assets/testimonials/maoli.jpg';
import andrewGemmell from '@/assets/testimonials/andrew-gemmell.jpg';
import killboy from '@/assets/testimonials/killboy.jpg';
import samAndSound from '@/assets/testimonials/sam-and-sound.jpg';
import industryVeteran from '@/assets/testimonials/industry-veteran.jpg';
import millionStreams from '@/assets/testimonials/million-streams.jpg';
import gerryMatthee from '@/assets/testimonials/gerry-matthee.jpg';
import joyFrostStats from '@/assets/testimonials/joy-frost-stats.jpg';
import vinceMillett from '@/assets/testimonials/vince-millett.jpeg';
import readyToGiveUp from '@/assets/testimonials/ready-to-give-up.jpg';
import jakeAlmanrode from '@/assets/testimonials/jake-almanrode.jpeg';

// New testimonial imports
import mikeSherm3m from '@/assets/testimonials/mike-sherm-3m-streams.jpeg';
import academyLovingIt from '@/assets/testimonials/academy-loving-it.jpg';
import katieColePlaylists from '@/assets/testimonials/katie-cole-multiple-playlists.jpg';
import benWolfeWorldClass from '@/assets/testimonials/ben-wolfe-world-class.jpeg';
import johnDuff8m from '@/assets/testimonials/john-duff-8m-streams.jpg';
import dkmbaBestInvestment from '@/assets/testimonials/dkmba-best-investment.jpg';
import hansiTiktok500k from '@/assets/testimonials/hansi-tiktok-500k-views.jpg';
import kellyPaigeMomentum from '@/assets/testimonials/kelly-paige-momentum.jpg';
import kaylebellTiktok from '@/assets/testimonials/kaylee-bell-tiktok-views.jpeg';
import spotifyEditorialCountry from '@/assets/testimonials/spotify-editorial-country.jpg';
import kateWooFirstWeek from '@/assets/testimonials/kat-woo-first-week.jpg';
import robbGrantSpotifyAlgo from '@/assets/testimonials/robb-grant-spotify-algorithm.jpg';
import davidKupermanGameChanger from '@/assets/testimonials/david-kuperman-game-changer.jpg';
import paulMiddleton450k from '@/assets/testimonials/paul-middleton-450k-streams.jpeg';
import andrewGemmellTiktok260k from '@/assets/testimonials/andrew-gemmell-tiktok-260k.jpeg';
import lauraDubinCurator from '@/assets/testimonials/laura-dubin-curator-reach.jpg';
import lukeWestonEditorial from '@/assets/testimonials/luke-weston-spotify-editorial.jpg';
import mikeDimes10m from '@/assets/testimonials/mike-dimes-10m-streams.jpg';
import enzoBelloGrowth from '@/assets/testimonials/enzo-bello-streams-growth.jpg';
import kaylebellStats from '@/assets/testimonials/kaylee-bell-stats-growth.jpeg';
import spotifyCuratorReal from '@/assets/testimonials/spotify-curator-real-connection.jpg';
import davidStricklandFestival from '@/assets/testimonials/david-strickland-festival-booking.jpg';
import spencerCrandall1m from '@/assets/testimonials/spencer-crandall-1m-streams.jpg';
import emmaStevens200k from '@/assets/testimonials/emma-stevens-200k-spotify.jpg';
import artistStruggling from '@/assets/testimonials/artist-struggling-hope.jpg';
import artistBreakthrough from '@/assets/testimonials/artist-breakthrough-moment.jpg';
import curatorLove from '@/assets/testimonials/curator-love.jpeg';
import chrisLoganEditorial from '@/assets/testimonials/chris-logan-editorial.jpg';
import toshAlexanderPlaylist from '@/assets/testimonials/tosh-alexander-playlist-success.jpg';
import mitchRossell3m from '@/assets/testimonials/mitch-rossell-3m-streams.jpg';
import taylorGreyGrowth from '@/assets/testimonials/taylor-grey-listener-growth.jpg';
import gingerCoyleViral from '@/assets/testimonials/ginger-coyle-viral.jpg';
import newHopeClubGrowth from '@/assets/testimonials/new-hope-club-spotify-growth.jpg';
import academyResultsCourse from '@/assets/testimonials/academy-results-course.jpg';
import danielleBradbery from '@/assets/testimonials/danielle-bradbery-playlist.jpg';
import tiffanyWoysGrowth from '@/assets/testimonials/tiffany-woys-spotify-growth.jpg';
import artistTractionBuilding from '@/assets/testimonials/artist-traction-building.jpg';
import brianMichaelGrowth from '@/assets/testimonials/brian-michael-spotify-growth.jpg';
import artistEditorialWins from '@/assets/testimonials/artist-editorial-wins.jpg';
import spotifyCuratorRepost from '@/assets/testimonials/spotify-curator-repost.jpg';
import elianaGrowth from '@/assets/testimonials/eliana-artist-growth.jpg';
import andrewGemmell60k from '@/assets/testimonials/andrew-gemmell-60k-followers.jpg';
import chrisLogan35k from '@/assets/testimonials/chris-logan-35k-streams.jpg';
import liamFerrariConfidence from '@/assets/testimonials/liam-ferrari-confidence.jpg';
import nickMatteraEditorial from '@/assets/testimonials/nick-mattera-editorial.jpg';
import seanStephensTiktok from '@/assets/testimonials/sean-stephens-tiktok-growth.jpeg';
import academyStudentSuccess from '@/assets/testimonials/academy-student-success.jpg';
import dkmbaWorthInvestment from '@/assets/testimonials/dkmba-worth-investment.jpg';
import labelArtistMomentum from '@/assets/testimonials/label-artist-momentum.jpg';
import sammyArriagaGrowth from '@/assets/testimonials/sammy-arriaga-streaming-growth.jpg';
import emmaWhitePlaylists from '@/assets/testimonials/emma-white-playlist-wins.jpg';
import kelseaBalleriniGrowth from '@/assets/testimonials/kelsea-ballerini-growth.jpg';
import hardyStreamingSuccess from '@/assets/testimonials/hardy-streaming-success.jpg';
import roadTo1mCourse from '@/assets/testimonials/road-to-1m-course.jpg';
import carloPassavanti from '@/assets/testimonials/carlo-passavanti-all-new-rock.jpeg';
import genuineHelp from '@/assets/testimonials/genuine-help-testimonial.jpeg';
import andrewGemmell150k from '@/assets/testimonials/andrew-gemmell-150k-monthly.jpeg';
import debutSingle35k from '@/assets/testimonials/debut-single-35k-merch.jpeg';
import appleMusic22k from '@/assets/testimonials/22k-apple-music-nmd.jpg';
import michaelGilbride from '@/assets/testimonials/michael-gilbride-20k-streams.jpeg';
import drcheriseJoy from '@/assets/testimonials/drcherise-joy-45k-viral.jpg';
import lukinJoshua from '@/assets/testimonials/lukin-joshua-festival-booking.jpg';
import memo71Tiktok from '@/assets/testimonials/memo71-tiktok-4981.jpg';
import kyivFrance from '@/assets/testimonials/kyiv-france-36k-tiktok.jpg';
import artist1mSpotify from '@/assets/testimonials/artist-1m-spotify-streams.jpg';
import andrewGemmellSamSounds from '@/assets/testimonials/andrew-gemmell-sam-sounds-2-8m.jpg';
import rudolfTvardochlib from '@/assets/testimonials/rudolf-tvardochlib-fan-engagement.jpg';
import artistBeliefSuccess from '@/assets/testimonials/artist-belief-success.jpg';
import academyPractical from '@/assets/testimonials/academy-practical-valuable.jpg';
import ryanCookEditorial from '@/assets/testimonials/ryan-cook-editorial-growth.jpg';
import codyJohnsonPlaylists from '@/assets/testimonials/cody-johnson-playlist-wins.jpg';
import tiktok52kViews from '@/assets/testimonials/tiktok-views-52k.jpeg';
import chrisPierceGrowth from '@/assets/testimonials/chris-pierce-growth.jpeg';
import williamManzano from '@/assets/testimonials/william-manzano.jpg';

export interface Testimonial {
  id: string;
  image: string;
  alt: string;
  category: 'mega-wins' | 'editorial' | 'viral' | 'milestones' | 'emotional' | 'academy';
  priority: number;
}

export const allTestimonials: Testimonial[] = [
  // Top priority - Keep existing testimonials at the top (positions 1-11)
  { 
    id: 'maoli', 
    image: maoli, 
    alt: "Maoli - 414k monthly listeners growth", 
    category: 'mega-wins',
    priority: 1 
  },
  { 
    id: 'andrewGemmell', 
    image: andrewGemmell, 
    alt: "Andrew Gemmell - 500k streams and 60k Instagram followers", 
    category: 'milestones',
    priority: 2 
  },
  { 
    id: 'killboy', 
    image: killboy, 
    alt: "killboy - 71K Instagram followers, learned more in 1 day than 3 years on Atlantic Records", 
    category: 'emotional',
    priority: 3 
  },
  { 
    id: 'samAndSound', 
    image: samAndSound, 
    alt: "Sam and Sound - 2M streams, heartfelt thanks", 
    category: 'mega-wins',
    priority: 4 
  },
  { 
    id: 'industryVeteran', 
    image: industryVeteran, 
    alt: "Industry veteran - powerful testimonial", 
    category: 'emotional',
    priority: 5 
  },
  { 
    id: 'millionStreams', 
    image: millionStreams, 
    alt: "1 million streams milestone achievement", 
    category: 'mega-wins',
    priority: 6 
  },
  { 
    id: 'gerryMatthee', 
    image: gerryMatthee, 
    alt: "Gerry Matthee - 100K+ Apple Music streams, multi-platform editorial playlists", 
    category: 'editorial',
    priority: 7 
  },
  { 
    id: 'joyFrostStats', 
    image: joyFrostStats, 
    alt: "Joy Frost - 1.6M streams success", 
    category: 'mega-wins',
    priority: 8 
  },
  { 
    id: 'vinceMillett', 
    image: vinceMillett, 
    alt: "Vince Millett - 114.1K streams on Spotify Wrapped", 
    category: 'milestones',
    priority: 9 
  },
  { 
    id: 'readyToGiveUp', 
    image: readyToGiveUp, 
    alt: "Artist on verge of giving up - 2 Spotify Editorial Playlists", 
    category: 'emotional',
    priority: 10 
  },
  { 
    id: 'jakeAlmanrode', 
    image: jakeAlmanrode, 
    alt: "Jake Almanrode - 158K streams, aiming for 1M+", 
    category: 'milestones',
    priority: 11 
  },

  // New testimonials (batch 1-14)
  { 
    id: 'mikeSherm3m', 
    image: mikeSherm3m, 
    alt: "Mike Sherm - 3M streams success", 
    category: 'mega-wins',
    priority: 12 
  },
  { 
    id: 'academyLovingIt', 
    image: academyLovingIt, 
    alt: "Academy student loving the course", 
    category: 'academy',
    priority: 13 
  },
  { 
    id: 'katieColePlaylists', 
    image: katieColePlaylists, 
    alt: "Katie Cole - Multiple playlist placements", 
    category: 'editorial',
    priority: 14 
  },
  { 
    id: 'benWolfeWorldClass', 
    image: benWolfeWorldClass, 
    alt: "Ben Wolfe - World class music business education", 
    category: 'academy',
    priority: 15 
  },
  { 
    id: 'johnDuff8m', 
    image: johnDuff8m, 
    alt: "John Duff - 8M streams milestone", 
    category: 'mega-wins',
    priority: 16 
  },
  { 
    id: 'dkmbaBestInvestment', 
    image: dkmbaBestInvestment, 
    alt: "DKMBA - Best investment in music career", 
    category: 'academy',
    priority: 46 
  },
  { 
    id: 'hansiTiktok500k', 
    image: hansiTiktok500k, 
    alt: "Hansi - 500K TikTok views", 
    category: 'viral',
    priority: 18 
  },
  { 
    id: 'kellyPaigeMomentum', 
    image: kellyPaigeMomentum, 
    alt: "Kelly Paige - Building unstoppable momentum", 
    category: 'milestones',
    priority: 19 
  },
  { 
    id: 'kaylebellTiktok', 
    image: kaylebellTiktok, 
    alt: "Kaylee Bell - Massive TikTok view growth", 
    category: 'viral',
    priority: 20 
  },
  { 
    id: 'spotifyEditorialCountry', 
    image: spotifyEditorialCountry, 
    alt: "Artist featured on Spotify Editorial Country playlist", 
    category: 'editorial',
    priority: 21 
  },
  { 
    id: 'kateWooFirstWeek', 
    image: kateWooFirstWeek, 
    alt: "Kat Woo - Incredible results in first week", 
    category: 'milestones',
    priority: 22 
  },
  { 
    id: 'robbGrantSpotifyAlgo', 
    image: robbGrantSpotifyAlgo, 
    alt: "Robb Grant - Mastering Spotify algorithm", 
    category: 'editorial',
    priority: 23 
  },
  { 
    id: 'davidKupermanGameChanger', 
    image: davidKupermanGameChanger, 
    alt: "David Kuperman - Complete game changer", 
    category: 'emotional',
    priority: 24 
  },
  { 
    id: 'paulMiddleton450k', 
    image: paulMiddleton450k, 
    alt: "Paul Middleton - 450K streams milestone", 
    category: 'milestones',
    priority: 25 
  },
  { 
    id: 'williamManzano', 
    image: williamManzano, 
    alt: "William Manzano - Artist success story", 
    category: 'milestones',
    priority: 26 
  },
  { 
    id: 'andrewGemmellTiktok260k', 
    image: andrewGemmellTiktok260k, 
    alt: "Andrew Gemmell - 260K TikTok reach", 
    category: 'viral',
    priority: 27 
  },
  { 
    id: 'lauraDubinCurator', 
    image: lauraDubinCurator, 
    alt: "Laura Dubin - Massive curator reach", 
    category: 'editorial',
    priority: 28 
  },
  { 
    id: 'lukeWestonEditorial', 
    image: lukeWestonEditorial, 
    alt: "Luke Weston - Spotify Editorial playlist win", 
    category: 'editorial',
    priority: 29 
  },
  { 
    id: 'mikeDimes10m', 
    image: mikeDimes10m, 
    alt: "Mike Dimes - 10M streams achievement", 
    category: 'mega-wins',
    priority: 30 
  },
  { 
    id: 'enzoBelloGrowth', 
    image: enzoBelloGrowth, 
    alt: "Enzo Bello - Explosive stream growth", 
    category: 'milestones',
    priority: 31 
  },
  { 
    id: 'kaylebellStats', 
    image: kaylebellStats, 
    alt: "Kaylee Bell - Comprehensive stats growth", 
    category: 'milestones',
    priority: 32 
  },
  { 
    id: 'spotifyCuratorReal', 
    image: spotifyCuratorReal, 
    alt: "Spotify curator praising genuine connection approach", 
    category: 'editorial',
    priority: 33 
  },
  { 
    id: 'davidStricklandFestival', 
    image: davidStricklandFestival, 
    alt: "David Strickland - Festival booking success", 
    category: 'milestones',
    priority: 34 
  },
  { 
    id: 'spencerCrandall1m', 
    image: spencerCrandall1m, 
    alt: "Spencer Crandall - 1M streams milestone", 
    category: 'mega-wins',
    priority: 35 
  },
  { 
    id: 'emmaStevens200k', 
    image: emmaStevens200k, 
    alt: "Emma Stevens - 200K Spotify streams", 
    category: 'milestones',
    priority: 36 
  },
  { 
    id: 'artistStruggling', 
    image: artistStruggling, 
    alt: "Artist finding hope after struggling", 
    category: 'emotional',
    priority: 37 
  },
  { 
    id: 'artistBreakthrough', 
    image: artistBreakthrough, 
    alt: "Artist experiencing breakthrough moment", 
    category: 'emotional',
    priority: 38 
  },
  { 
    id: 'curatorLove', 
    image: curatorLove, 
    alt: "Curator expressing love for artist outreach quality", 
    category: 'editorial',
    priority: 39 
  },
  { 
    id: 'chrisLoganEditorial', 
    image: chrisLoganEditorial, 
    alt: "Chris Logan - First Spotify editorial playlist", 
    category: 'editorial',
    priority: 40 
  },
  { 
    id: 'toshAlexanderPlaylist', 
    image: toshAlexanderPlaylist, 
    alt: "Tosh Alexander - Playlist placement success", 
    category: 'editorial',
    priority: 41 
  },
  { 
    id: 'mitchRossell3m', 
    image: mitchRossell3m, 
    alt: "Mitch Rossell - 3M streams achievement", 
    category: 'mega-wins',
    priority: 42 
  },
  { 
    id: 'taylorGreyGrowth', 
    image: taylorGreyGrowth, 
    alt: "Taylor Grey - Monthly listener growth", 
    category: 'milestones',
    priority: 43 
  },
  { 
    id: 'gingerCoyleViral', 
    image: gingerCoyleViral, 
    alt: "Ginger Coyle - Viral success story", 
    category: 'viral',
    priority: 44 
  },
  { 
    id: 'newHopeClubGrowth', 
    image: newHopeClubGrowth, 
    alt: "New Hope Club - Spotify growth success", 
    category: 'milestones',
    priority: 45 
  },
  { 
    id: 'academyResultsCourse', 
    image: academyResultsCourse, 
    alt: "Academy student seeing real results from course", 
    category: 'academy',
    priority: 17 
  },
  { 
    id: 'danielleBradbery', 
    image: danielleBradbery, 
    alt: "Danielle Bradbery - Playlist placement", 
    category: 'editorial',
    priority: 47 
  },
  { 
    id: 'tiffanyWoysGrowth', 
    image: tiffanyWoysGrowth, 
    alt: "Tiffany Woys - Spotify growth trajectory", 
    category: 'milestones',
    priority: 48 
  },
  { 
    id: 'artistTractionBuilding', 
    image: artistTractionBuilding, 
    alt: "Artist building real traction", 
    category: 'milestones',
    priority: 49 
  },
  { 
    id: 'brianMichaelGrowth', 
    image: brianMichaelGrowth, 
    alt: "Brian Michael - Spotify growth success", 
    category: 'milestones',
    priority: 50 
  },
  { 
    id: 'artistEditorialWins', 
    image: artistEditorialWins, 
    alt: "Artist celebrating multiple editorial wins", 
    category: 'editorial',
    priority: 51 
  },
  { 
    id: 'spotifyCuratorRepost', 
    image: spotifyCuratorRepost, 
    alt: "Spotify curator reposting artist success", 
    category: 'editorial',
    priority: 52 
  },
  { 
    id: 'elianaGrowth', 
    image: elianaGrowth, 
    alt: "Eliana - Consistent growth trajectory", 
    category: 'milestones',
    priority: 53 
  },
  { 
    id: 'andrewGemmell60k', 
    image: andrewGemmell60k, 
    alt: "Andrew Gemmell - 60K follower milestone", 
    category: 'milestones',
    priority: 54 
  },
  { 
    id: 'chrisLogan35k', 
    image: chrisLogan35k, 
    alt: "Chris Logan - 35K streams on debut single", 
    category: 'milestones',
    priority: 55 
  },
  { 
    id: 'liamFerrariConfidence', 
    image: liamFerrariConfidence, 
    alt: "Liam Ferrari - Gaining confidence in music career", 
    category: 'emotional',
    priority: 56 
  },
  { 
    id: 'nickMatteraEditorial', 
    image: nickMatteraEditorial, 
    alt: "Nick Mattera - Editorial playlist success", 
    category: 'editorial',
    priority: 57 
  },
  { 
    id: 'seanStephensTiktok', 
    image: seanStephensTiktok, 
    alt: "Sean Stephens - TikTok growth explosion", 
    category: 'viral',
    priority: 58 
  },
  { 
    id: 'academyStudentSuccess', 
    image: academyStudentSuccess, 
    alt: "Academy student achieving breakthrough success", 
    category: 'academy',
    priority: 59 
  },
  { 
    id: 'dkmbaWorthInvestment', 
    image: dkmbaWorthInvestment, 
    alt: "DKMBA - Worth every penny investment", 
    category: 'academy',
    priority: 60 
  },
  { 
    id: 'labelArtistMomentum', 
    image: labelArtistMomentum, 
    alt: "Label artist building unstoppable momentum", 
    category: 'milestones',
    priority: 61 
  },
  { 
    id: 'sammyArriagaGrowth', 
    image: sammyArriagaGrowth, 
    alt: "Sammy Arriaga - Streaming growth success", 
    category: 'milestones',
    priority: 62 
  },
  { 
    id: 'emmaWhitePlaylists', 
    image: emmaWhitePlaylists, 
    alt: "Emma White - Multiple playlist wins", 
    category: 'editorial',
    priority: 63 
  },
  { 
    id: 'kelseaBalleriniGrowth', 
    image: kelseaBalleriniGrowth, 
    alt: "Kelsea Ballerini - Growth milestone", 
    category: 'milestones',
    priority: 64 
  },
  { 
    id: 'hardyStreamingSuccess', 
    image: hardyStreamingSuccess, 
    alt: "Hardy - Streaming success achievement", 
    category: 'mega-wins',
    priority: 65 
  },
  { 
    id: 'roadTo1mCourse', 
    image: roadTo1mCourse, 
    alt: "Road to 1M Course - 100+ new followers in 3 days", 
    category: 'academy',
    priority: 66 
  },
  { 
    id: 'carloPassavanti', 
    image: carloPassavanti, 
    alt: "Carlo Passavanti - All New Rock editorial playlist", 
    category: 'editorial',
    priority: 67 
  },
  { 
    id: 'genuineHelp', 
    image: genuineHelp, 
    alt: "Artist thanking for genuine help and support", 
    category: 'emotional',
    priority: 68 
  },
  { 
    id: 'andrewGemmell150k', 
    image: andrewGemmell150k, 
    alt: "Andrew Gemmell - 150K monthly listeners", 
    category: 'milestones',
    priority: 69 
  },
  { 
    id: 'debutSingle35k', 
    image: debutSingle35k, 
    alt: "Debut single 35K streams and merch line launch", 
    category: 'milestones',
    priority: 70 
  },
  { 
    id: 'appleMusic22k', 
    image: appleMusic22k, 
    alt: "22K Apple Music streams with 4 NMD placements", 
    category: 'editorial',
    priority: 71 
  },
  { 
    id: 'michaelGilbride', 
    image: michaelGilbride, 
    alt: "Michael Gilbride - 20,000 streams milestone", 
    category: 'milestones',
    priority: 72 
  },
  { 
    id: 'drcheriseJoy', 
    image: drcheriseJoy, 
    alt: "DrCherise Joy Thompson - Viral reel 45,000+ accounts reached", 
    category: 'viral',
    priority: 73 
  },
  { 
    id: 'lukinJoshua', 
    image: lukinJoshua, 
    alt: "Lukin Joshua Potgieter - DKMBA success with festival booking", 
    category: 'milestones',
    priority: 74 
  },
  { 
    id: 'memo71Tiktok', 
    image: memo71Tiktok, 
    alt: "Memo71 band - TikTok growth to 4,981 followers", 
    category: 'viral',
    priority: 75 
  },
  { 
    id: 'kyivFrance', 
    image: kyivFrance, 
    alt: "Artist from Kyiv building career in France - 36K TikTok followers", 
    category: 'viral',
    priority: 76 
  },
  { 
    id: 'artist1mSpotify', 
    image: artist1mSpotify, 
    alt: "Artist hitting 1M Spotify streams milestone", 
    category: 'mega-wins',
    priority: 77 
  },
  { 
    id: 'andrewGemmellSamSounds', 
    image: andrewGemmellSamSounds, 
    alt: "Andrew Gemmell - Sam and Sounds reaching 2.8M streams", 
    category: 'mega-wins',
    priority: 78 
  },
  { 
    id: 'rudolfTvardochlib', 
    image: rudolfTvardochlib, 
    alt: "Rudolf Christian Tvardochlib - Organic fan engagement", 
    category: 'milestones',
    priority: 79 
  },
  { 
    id: 'artistBeliefSuccess', 
    image: artistBeliefSuccess, 
    alt: "Artist gaining belief in their success", 
    category: 'emotional',
    priority: 80 
  },
  { 
    id: 'academyPractical', 
    image: academyPractical, 
    alt: "Academy student praising practical and valuable content", 
    category: 'academy',
    priority: 81 
  },
  { 
    id: 'ryanCookEditorial', 
    image: ryanCookEditorial, 
    alt: "Ryan Cook - Editorial growth success", 
    category: 'editorial',
    priority: 82 
  },
  { 
    id: 'codyJohnsonPlaylists', 
    image: codyJohnsonPlaylists, 
    alt: "Cody Johnson - Multiple playlist wins", 
    category: 'editorial',
    priority: 83 
  },
  { 
    id: 'tiktok52kViews', 
    image: tiktok52kViews, 
    alt: "Artist achieving 52K TikTok views", 
    category: 'viral',
    priority: 84 
  },
  { 
    id: 'chrisPierceGrowth', 
    image: chrisPierceGrowth, 
    alt: "Chris Pierce - Steady growth success", 
    category: 'milestones',
    priority: 85 
  },
];
